import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { NewsComponent } from './news.component';
import { NewsRssService } from './news-rss.service';

@NgModule({
  declarations: [
    NewsComponent
  ],
  exports: [
    NewsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [NewsRssService]
})
export class NewsModule { }
